// ============================================
// components/porchlight/PorchlightLamp.js
// ============================================
import React from 'react';
import { createPortal } from 'react-dom';

const PorchlightLamp = ({ isActive, onClick, disabled, onFocusToggle, overlayHostEl }) => {
  return (
    <div className="lamp-container">
      {isActive ? (
        <>
          <button
            className="lamp-button lamp-button-on"
            onClick={onClick}
            disabled={disabled}
            aria-label="Turn off porch light"
            aria-pressed={true}
            style={{ pointerEvents: 'auto' }}
            data-testid="porchlight-toggle"
            type="button"
            onFocus={onFocusToggle}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }}
          />
          {/* If an overlay host exists, render only the glow there. Keep the lamp hardware locally. */}
          {overlayHostEl && createPortal(
            <img
              src="/on.svg"
              alt=""
              role="presentation"
              aria-hidden="true"
              className="lamp-glow-overlay lamp-animated"
              draggable={false}
              loading="lazy"
              style={{ pointerEvents: 'none' }}
            />,
            overlayHostEl
          )}
          {/* Fallback: if no overlay host, render the glow locally */}
          {!overlayHostEl && (
            <img
              src="/on.svg"
              alt=""
              role="presentation"
              aria-hidden="true"
              className="lamp-glow-overlay lamp-animated"
              draggable={false}
              loading="lazy"
              style={{ pointerEvents: 'none' }}
            />
          )}
          {/* Lamp hardware remains local for correct stacking and click alignment */}
          <img
            src="/light.svg"
            alt="Porchlight On"
            className="lamp-animated lamp-on-glow"
            draggable={false}
            style={{ pointerEvents: 'none' }}
            data-testid="porchlight-toggle-image"
            loading="lazy"
          />
        </>
      ) : (
        <>
          <button
            className="lamp-button lamp-button-off"
            onClick={onClick}
            disabled={disabled}
            aria-label="Turn on porch light"
            aria-pressed={false}
            style={{ pointerEvents: 'auto' }}
            data-testid="porchlight-toggle"
            type="button"
            aria-haspopup="dialog"
            onFocus={onFocusToggle}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }}
          />
          <img
            src="/off.svg"
            alt="Porchlight Off"
            className="lamp-off-img lamp-animated"
            draggable={false}
            style={{ pointerEvents: 'none', cursor: disabled ? 'not-allowed' : 'pointer' }}
            data-testid="porchlight-toggle-image"
            onFocus={onFocusToggle}
            loading="lazy"
          />
        </>
      )}
    </div>
  );
};

export default PorchlightLamp;
